export interface LoyaltyTierWorkStepConfig {
	title: string
	description: string
}

export const LOYALTY_TIER_WORK_STEPS: LoyaltyTierWorkStepConfig[] = [
	{
		title: 'Tier Title',
		description:
			"Each tier has a unique title representing your status level. As you accumulate more points, you'll advance to higher tiers with better rewards and exclusive benefits.",
	},
	{
		title: 'Points Required',
		description:
			'Points are earned through gameplay and wagering. Each tier requires a minimum number of points to unlock. Keep playing to accumulate points and climb the loyalty ladder.',
	},
	{
		title: 'Daily Rakeback',
		description:
			'Receive a percentage of your daily wagers back as rakeback. Higher tiers unlock better daily rakeback rates, giving you more value from your everyday gameplay.',
	},
	{
		title: 'Weekly Cashback',
		description: 'Get weekly cashback based on your activity. As you climb tiers, your weekly cashback percentage increases and is paid out on a regular weekly schedule.',
	},
	{
		title: 'Monthly Cashback',
		description:
			'In addition to weekly rewards, receive a monthly cashback bonus based on your tier level. This is calculated from your total monthly activity and paid out at the end of each month.',
	},
	{
		title: 'Daily Bonus',
		description: 'Eligible tiers receive a fixed daily bonus credited in your chosen currency. Log in and play regularly to make the most of this recurring reward.',
	},
	{
		title: 'Weekly Bonus',
		description: 'Unlock a weekly bonus payout that grows with your tier. This reward is designed to recognize consistent play throughout the week.',
	},
	{
		title: 'Monthly Bonus',
		description: 'Higher loyalty tiers can unlock a monthly bonus on top of weekly rewards, giving long-term players an extra boost at the end of each month.',
	},
	{
		title: 'Daily Free Spins',
		description: 'Some tiers include a set number of free spins every day. Use them on eligible games to play without spending your balance.',
	},
	{
		title: 'Weekly Free Spins',
		description: 'Weekly free spins are awarded on a recurring schedule and increase at higher tiers, giving you more chances to win each week.',
	},
	{
		title: 'Monthly Free Spins',
		description: 'Top tiers can unlock a larger monthly free spin allowance, rewarding sustained loyalty with extra gameplay opportunities.',
	},
	{
		title: 'Level Up Bonus',
		description: 'When you advance to a new loyalty level, you may receive a one-time bonus credited in your tier currency as a reward for progressing.',
	},
	{
		title: 'Level Up Free Spins',
		description: 'Reaching a new level can also grant a bundle of free spins, giving you an immediate reward when you move up the loyalty ladder.',
	},
	{
		title: 'Daily Withdrawal Limit',
		description: 'Each tier defines how much you can withdraw per day. Higher tiers unlock increased daily withdrawal limits for greater flexibility.',
	},
]
